import { render, staticRenderFns } from "./DocumentCategorySection.vue?vue&type=template&id=1298ccdd&scoped=true"
import script from "./DocumentCategorySection.vue?vue&type=script&lang=js"
export * from "./DocumentCategorySection.vue?vue&type=script&lang=js"
import style0 from "./DocumentCategorySection.vue?vue&type=style&index=0&id=1298ccdd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1298ccdd",
  null
  
)

export default component.exports